import { Flow } from 'signup-constants/Flow';
export const RequiredQueryParamsByFlow = new Map([[Flow.FbCrm, ['page_id']], [Flow.Integrations, ['integration']], [Flow.Microapp, ['microapp']], [Flow.Trial, ['trialid']]]);